const { useEffect } = wp.element;

const Style = ({ attributes, setAttributes }) => {
  const { uniqueId, primaryColor, hoverColor, bgColor, radius, width, CSS, align, skin } = attributes;

  useEffect(() => {
    const CSS = `#${uniqueId}{justify-content: ${align};--plyr-color-main: ${primaryColor}; --plyr-color-bg: ${bgColor}}#${uniqueId} .h5ap_standard_player {width: ${width};}#${uniqueId} .plyr__controls {background: ${bgColor};border-radius:${radius}}#${uniqueId} .radius{border-radius: ${radius}}#${uniqueId} .skin_default .plyr__control,#${uniqueId}{--theme-skin-wave-color: ${primaryColor};}`;

    setAttributes({ CSS });
  }, [width, bgColor, radius, uniqueId, hoverColor, primaryColor, align]);

  useEffect(() => {
    if (skin === "Default") {
      setAttributes({ bgColor: "#EEEEEE" });
    } else {
      setAttributes({ bgColor: "#232323" });
    }
  }, [skin]);

  return <style>{CSS}</style>;
};

export default Style;
